export default __webpack_public_path__ + "static/media/Königspinguin.eb1a44f1.jpg";